import { Component, OnInit } from '@angular/core';
import { NotificationService, DataService, Dialog, SharedModule } from '@vendure/admin-ui/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CreateBulkTimeSlotsDocument, CreateBulkTimeSlotsInput } from '../../generated-types';

@Component({
    selector: 'bulk-create-time-slots-modal',
    templateUrl: './bulk-create-modal.component.html',
    standalone: true,
    imports: [SharedModule],
})
export class BulkTimeSlotModalComponent implements OnInit, Dialog<any> {
    resolveWith!: (result?: CreateBulkTimeSlotsInput) => void;

    form: FormGroup;
    minDate: string;

    constructor(
        private fb: FormBuilder,
        private dataService: DataService,
        private notificationService: NotificationService,
    ) {
        this.form = this.fb.group({
            startDate: ['', Validators.required],
            endDate: [''],
            startTime: ['', Validators.required],
            endTime: [''],
            slotDurationInMinutes: [30, Validators.required],
            maxOrdersPerSlot: [5, Validators.required],
        });
    }

    ngOnInit(): void {
        const today = new Date();
        this.minDate = today.toISOString().split('T')[0];
    }

    create() {
        const input = this.form.value;

        this.dataService.mutate(CreateBulkTimeSlotsDocument, { input }).subscribe({
            next: ({ createBulkTimeSlots }) => {
                if (createBulkTimeSlots.success) {
                    this.resolveWith({
                        startDate: this.form.value.startDate,
                        endDate: this.form.value.endDate,
                        startTime: this.form.value.startTime,
                        endTime: this.form.value.endTime,
                        slotDurationInMinutes: this.form.value.slotDurationInMinutes,
                        maxOrdersPerSlot: this.form.value.maxOrdersPerSlot,
                    });
                } else {
                    this.resolveWith();
                    this.notificationService.error('Error Failed to create bulk time slots');
                }
            },
            error: err => {
                this.resolveWith();
            },
        });
    }

    cancel() {
        this.resolveWith();
    }
}
